module.exports = __webpack_public_path__ + "img/Fond_ballons.2117424.jpg";